import { EventEmitter, Directive, ElementRef, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import '@cds/core/file/register.js';

/*
 * Copyright (c) 2016-2021 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import * as ɵngcc0 from '@angular/core';
class CdsFileDirective {
    constructor(elementRef) {
        this.layoutChange = new EventEmitter();
        this.element = elementRef.nativeElement;
    }
    get i18n() {
        return this.element.i18n;
    }
    set i18n(value) {
        this.element.i18n = value;
    }
    get status() {
        return this.element.status;
    }
    set status(value) {
        this.element.status = value;
    }
    get controlWidth() {
        return this.element.controlWidth;
    }
    set controlWidth(value) {
        this.element.controlWidth = value;
    }
    get validate() {
        return this.element.validate;
    }
    set validate(value) {
        this.element.validate = !!value;
    }
    get responsive() {
        return this.element.responsive;
    }
    set responsive(value) {
        this.element.responsive = !!value;
    }
    get layout() {
        return this.element.layout;
    }
    set layout(value) {
        this.element.layout = value;
    }
}
CdsFileDirective.ɵfac = function CdsFileDirective_Factory(t) { return new (t || CdsFileDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CdsFileDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CdsFileDirective, selectors: [["cds-file"]], inputs: { i18n: "i18n", status: "status", controlWidth: "controlWidth", validate: "validate", responsive: "responsive", layout: "layout" }, outputs: { layoutChange: "layoutChange" } });
CdsFileDirective.ctorParameters = () => [
    { type: ElementRef }
];
CdsFileDirective.propDecorators = {
    i18n: [{ type: Input }],
    status: [{ type: Input }],
    controlWidth: [{ type: Input }],
    validate: [{ type: Input }],
    responsive: [{ type: Input }],
    layout: [{ type: Input }],
    layoutChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CdsFileDirective, [{
        type: Directive,
        args: [{ selector: 'cds-file' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { layoutChange: [{
            type: Output
        }], i18n: [{
            type: Input
        }], status: [{
            type: Input
        }], controlWidth: [{
            type: Input
        }], validate: [{
            type: Input
        }], responsive: [{
            type: Input
        }], layout: [{
            type: Input
        }] }); })();

/*
 * Copyright (c) 2016-2021 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
class CdsFileModule {
}
CdsFileModule.ɵfac = function CdsFileModule_Factory(t) { return new (t || CdsFileModule)(); };
CdsFileModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CdsFileModule });
CdsFileModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CdsFileModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [CdsFileDirective],
                exports: [CdsFileDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CdsFileModule, { declarations: function () { return [CdsFileDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CdsFileDirective]; } }); })();

/*
 * Copyright (c) 2016-2021 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

/*
 * Public API Surface of cds-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CdsFileDirective, CdsFileModule };

